export const defaultFormats = {
	date: {
		standard: 'MM/DD/YYYY',
		datetime: 'MM/DD/YYYY HH:mm',
	},
	currency: {
		format: {
			pos: '%s%v',
			neg: '(%s%v)',
			zero: '%s%v',
		},
		decimal: '.',
		thousand: ',',
		precision: 2,
	},
};

export const formats = {
	GB: {
		date: {
			standard: 'DD/MM/YYYY',
			datetime: 'DD/MM/YYYY HH:mm',
		},
	},

	IE: {
		date: {
			standard: 'DD/MM/YYYY',
			datetime: 'DD/MM/YYYY HH:mm',
		},
	},

	AU: {
		date: {
			standard: 'DD/MM/YYYY',
			datetime: 'DD/MM/YYYY HH:mm',
		},
	},

	NZ: {
		date: {
			standard: 'DD/MM/YYYY',
			datetime: 'DD/MM/YYYY HH:mm',
		},
	},
	'fr-CA': {
		date: {
			standard: 'YYYY-MM-DD',
			datetime: 'YYYY-MM-DD HH:mm',
		},
		currency: {
			format: {
				pos: '%s%v',
				neg: '-%s%v',
				zero: '%s%v',
			},
			decimal: ',',
			thousand: ' ',
			precision: 2,
		},
	},
};

export default function getFormat(country, locale) {
	const prop = locale && locale !== 'en-US' ? locale : country;

	if (formats[prop]) {
		return Object.assign({}, defaultFormats, formats[prop]);
	}

	return defaultFormats;
}

export function getDateFormat(country, locale) {
	return getFormat(country, locale).date;
}

export function getCurrencyFormat(country, locale) {
	return getFormat(country, locale).currency;
}



// WEBPACK FOOTER //
// ./src/ui/i18n/formats.js